const partnerReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_PARTNER':
            // state = [...state, action.payload];
            return action.payload;
        case 'UNSET_PARTNER':
            return [];
        default:
            return state;
    }
};

export default partnerReducer;